// extracted by mini-css-extract-plugin
export default {"root":"AddGroupActivityModal_root__HdRUW","container":"AddGroupActivityModal_container__z-jUe"};